/* eslint-disable consistent-return */
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';
import FileUploadWithValidation from '@/components/Validation/FileUploadWithValidation';
import MDTextFieldWithValidation from '@/components/Validation/MDTextFieldWithValidation';
import MDTextField from '@/components/Validation/MDTextField';
import UnsavedChanges from '@/components/UnsavedChanges';
import QRCodeTemplateView from '@/components/QRCodeTemplate';
import { QRCodeTemplate, ULID } from '@/store/models';
import qrcodeTemplate from '@/store/modules/qrcodeTemplate';
import store from '@/store';
import { validation } from '@/_helpers/validation';
import media from '@/store/modules/media';
import { UploadItem } from '@/store/models/uploadPopup';
import UploadPopup from '@/components/UploadPopup';
import notifier from '@/_helpers/notifier';
import template from './Details.vue';

@Component({
	mixins: [template],
	components: {
		ValidationObserver,
		MDTextField,
		MDTextFieldWithValidation,
		UnsavedChanges,
		FileUploadWithValidation,
		QRCodeTemplateView,
		UploadPopup
	}
})
export default class Details extends Vue {
	@Prop() qrcodeTemplate!: QRCodeTemplate;

	@Prop() externalLoading!: boolean;

	item: QRCodeTemplate = null;

	loading: boolean = true;

	init: any = {} as any;

	isMounted: boolean;

	show: boolean = false;

	uploadPercentages: UploadItem[] = [];

	uploadPopupShow: boolean = false;

	image: File = null;

	async mounted(): Promise<void> {
		this.uploadPercentages.push({
			file: '',
			uploadPercentage: 0
		});
	}

	@Watch('externalLoading')
	async onDoneLoading(): Promise<void> {
		if (!this.externalLoading && !this.isMounted) {
			this.loading = false;
			this.isMounted = true;
			this.init = JSON.parse(JSON.stringify(this.qrcodeTemplate));
			this.item = JSON.parse(JSON.stringify(this.qrcodeTemplate));
		}
	}

	async update() {
		const isValid = await (this.$refs.form as any).validate();
		if (!isValid) {
			(this.$refs.qrcodeTemplateView as QRCodeTemplateView).openPanelBasedOnError(await (this.$refs.form as any).errors);
			return;
		}

		this.loading = true;

		let response: { imageID?: ULID } = {};

		try {
			response = await qrcodeTemplate.put(this.item);

			this.init = JSON.parse(JSON.stringify(this.item));
			notifier.success('updated', 'template');
		} catch (error) {
			// @ts-ignore
			(this.$refs.form as any).setErrors(validation.getErrors(error.data.errors));
			notifier.error('updating', 'template');
			this.loading = false;
			return;
		}

		if (response.imageID) {
			this.uploadPopupShow = true;
			this.uploadPercentages[0].file = this.image.name;
			try {
				await media.fileUpload({
					mediaID: response.imageID,
					file: this.image,
					fn: function(this: Details, progressEvent: any) {
						// Function for progress bar
						this.uploadPercentages[0].uploadPercentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
					}.bind(this)
				});
				notifier.success('uploaded', 'image');
			} catch (error) {
				// @ts-ignore
				(this.$refs.form as any).setErrors(validation.getErrors(error.data.errors));
				notifier.error('uploading', 'image');
			} finally {
				this.uploadPopupShow = false;
			}
		}

		this.loading = false;
	}

	get changes(): boolean {
		if (this.isMounted) {
			if ((this.$refs.unsavedChanges as UnsavedChanges).changes) {
				return true;
			}
			if (this.image) {
				return true;
			}
		}
		return false;
	}

	updateTemplate(item: QRCodeTemplate): void {
		this.item = item;
	}

	setImage(image: File): void {
		this.image = image;
	}
}
